import { useMemo } from 'react';
import { NumberParam, UrlUpdateType, useQueryParam, withDefault } from 'use-query-params';
import { Pagination } from 'components/pagination';

export const PAGE_QUERY_KEY = 'pagina';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UsePaginationReturn = {
	pageSize: number;
	currentPage: number;
	setCurrentPage: (newValue: NewValueType<number | null | undefined>, updateType?: UrlUpdateType | undefined) => void;
	Pagination: (props: { totalCount: number; onPageChange: (page: number) => void }) => React.JSX.Element;
};

export const usePagination = (pageSize: number): UsePaginationReturn => {
	const [currentPage, setCurrentPage] = useQueryParam(PAGE_QUERY_KEY, withDefault(NumberParam, 1));

	const PaginationElement = useMemo(
		() =>
			({ totalCount, onPageChange }: { totalCount: number; onPageChange: (page: number) => void }) =>
				(
					<Pagination
						currentPage={currentPage}
						totalPages={Math.ceil(totalCount / pageSize)}
						onPageChange={onPageChange}
					/>
				),
		[currentPage]
	);

	return {
		pageSize,
		currentPage,
		setCurrentPage,
		Pagination: PaginationElement
	};
};
